import { Spacer } from 'fastdo-react'

import MoveUpAnimation from '../components/MoveUpAnimation'
import PageBase from '../components/PageBase'
import { useAppT } from '../localization/config'

export default function AboutPage() {
  const t = useAppT()

  return (
    <PageBase title={t.about_title} subtitle={t.about_subtitle} scroolToTop>
      <MoveUpAnimation>
        <p>{t.about_text}</p>

        <ul className="list-[circle] mt-4">
          <li>{t.about_item_1}</li>
          <li>{t.about_item_2}</li>
          <li>{t.about_item_3}</li>
          <li>{t.about_item_4} ✨</li>
        </ul>
      </MoveUpAnimation>

      <Spacer size={30} />

      <MoveUpAnimation>
        <h2>{t.philosophy_title}</h2>
        <p>{t.philosophy_text}</p>

        <ul className="list-[circle] mt-4">
          <li>{t.philosophy_item_1}</li>
          <li>{t.philosophy_item_2}</li>
          <li>{t.philosophy_item_3} ✨</li>
        </ul>
      </MoveUpAnimation>
    </PageBase>
  )
}
